/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedAccountRouteImport } from './routes/_authed/account'
import { Route as AuthedAboutRouteImport } from './routes/_authed/about'
import { Route as AuthedTripsIndexRouteImport } from './routes/_authed/trips/index'
import { Route as AuthedSupportIndexRouteImport } from './routes/_authed/support/index'
import { Route as AuthedRidesIndexRouteImport } from './routes/_authed/rides/index'
import { Route as AuthedPassesIndexRouteImport } from './routes/_authed/passes/index'
import { Route as AuthedMetroIndexRouteImport } from './routes/_authed/metro/index'
import { Route as AuthedRidesIdRouteImport } from './routes/_authed/rides/$id'
import { Route as AuthedPassesIdRouteImport } from './routes/_authed/passes/$id'
import { Route as AuthedMetroIdRouteImport } from './routes/_authed/metro/$id'
import { Route as AuthedSupportCategoryIssueIdRouteImport } from './routes/_authed/support/$category/$issueId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountRoute = AuthedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAboutRoute = AuthedAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTripsIndexRoute = AuthedTripsIndexRouteImport.update({
  id: '/trips/',
  path: '/trips/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSupportIndexRoute = AuthedSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRidesIndexRoute = AuthedRidesIndexRouteImport.update({
  id: '/rides/',
  path: '/rides/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPassesIndexRoute = AuthedPassesIndexRouteImport.update({
  id: '/passes/',
  path: '/passes/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMetroIndexRoute = AuthedMetroIndexRouteImport.update({
  id: '/metro/',
  path: '/metro/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRidesIdRoute = AuthedRidesIdRouteImport.update({
  id: '/rides/$id',
  path: '/rides/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPassesIdRoute = AuthedPassesIdRouteImport.update({
  id: '/passes/$id',
  path: '/passes/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMetroIdRoute = AuthedMetroIdRouteImport.update({
  id: '/metro/$id',
  path: '/metro/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSupportCategoryIssueIdRoute =
  AuthedSupportCategoryIssueIdRouteImport.update({
    id: '/support/$category/$issueId',
    path: '/support/$category/$issueId',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRoute
  '/about': typeof AuthedAboutRoute
  '/account': typeof AuthedAccountRoute
  '/': typeof AuthedIndexRoute
  '/metro/$id': typeof AuthedMetroIdRoute
  '/passes/$id': typeof AuthedPassesIdRoute
  '/rides/$id': typeof AuthedRidesIdRoute
  '/metro': typeof AuthedMetroIndexRoute
  '/passes': typeof AuthedPassesIndexRoute
  '/rides': typeof AuthedRidesIndexRoute
  '/support': typeof AuthedSupportIndexRoute
  '/trips': typeof AuthedTripsIndexRoute
  '/support/$category/$issueId': typeof AuthedSupportCategoryIssueIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/about': typeof AuthedAboutRoute
  '/account': typeof AuthedAccountRoute
  '/': typeof AuthedIndexRoute
  '/metro/$id': typeof AuthedMetroIdRoute
  '/passes/$id': typeof AuthedPassesIdRoute
  '/rides/$id': typeof AuthedRidesIdRoute
  '/metro': typeof AuthedMetroIndexRoute
  '/passes': typeof AuthedPassesIndexRoute
  '/rides': typeof AuthedRidesIndexRoute
  '/support': typeof AuthedSupportIndexRoute
  '/trips': typeof AuthedTripsIndexRoute
  '/support/$category/$issueId': typeof AuthedSupportCategoryIssueIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/about': typeof AuthedAboutRoute
  '/_authed/account': typeof AuthedAccountRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/metro/$id': typeof AuthedMetroIdRoute
  '/_authed/passes/$id': typeof AuthedPassesIdRoute
  '/_authed/rides/$id': typeof AuthedRidesIdRoute
  '/_authed/metro/': typeof AuthedMetroIndexRoute
  '/_authed/passes/': typeof AuthedPassesIndexRoute
  '/_authed/rides/': typeof AuthedRidesIndexRoute
  '/_authed/support/': typeof AuthedSupportIndexRoute
  '/_authed/trips/': typeof AuthedTripsIndexRoute
  '/_authed/support/$category/$issueId': typeof AuthedSupportCategoryIssueIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/about'
    | '/account'
    | '/'
    | '/metro/$id'
    | '/passes/$id'
    | '/rides/$id'
    | '/metro'
    | '/passes'
    | '/rides'
    | '/support'
    | '/trips'
    | '/support/$category/$issueId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/about'
    | '/account'
    | '/'
    | '/metro/$id'
    | '/passes/$id'
    | '/rides/$id'
    | '/metro'
    | '/passes'
    | '/rides'
    | '/support'
    | '/trips'
    | '/support/$category/$issueId'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/about'
    | '/_authed/account'
    | '/_authed/'
    | '/_authed/metro/$id'
    | '/_authed/passes/$id'
    | '/_authed/rides/$id'
    | '/_authed/metro/'
    | '/_authed/passes/'
    | '/_authed/rides/'
    | '/_authed/support/'
    | '/_authed/trips/'
    | '/_authed/support/$category/$issueId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account': {
      id: '/_authed/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthedAccountRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/about': {
      id: '/_authed/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AuthedAboutRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/trips/': {
      id: '/_authed/trips/'
      path: '/trips'
      fullPath: '/trips'
      preLoaderRoute: typeof AuthedTripsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/support/': {
      id: '/_authed/support/'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthedSupportIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/rides/': {
      id: '/_authed/rides/'
      path: '/rides'
      fullPath: '/rides'
      preLoaderRoute: typeof AuthedRidesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/passes/': {
      id: '/_authed/passes/'
      path: '/passes'
      fullPath: '/passes'
      preLoaderRoute: typeof AuthedPassesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metro/': {
      id: '/_authed/metro/'
      path: '/metro'
      fullPath: '/metro'
      preLoaderRoute: typeof AuthedMetroIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/rides/$id': {
      id: '/_authed/rides/$id'
      path: '/rides/$id'
      fullPath: '/rides/$id'
      preLoaderRoute: typeof AuthedRidesIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/passes/$id': {
      id: '/_authed/passes/$id'
      path: '/passes/$id'
      fullPath: '/passes/$id'
      preLoaderRoute: typeof AuthedPassesIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/metro/$id': {
      id: '/_authed/metro/$id'
      path: '/metro/$id'
      fullPath: '/metro/$id'
      preLoaderRoute: typeof AuthedMetroIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/support/$category/$issueId': {
      id: '/_authed/support/$category/$issueId'
      path: '/support/$category/$issueId'
      fullPath: '/support/$category/$issueId'
      preLoaderRoute: typeof AuthedSupportCategoryIssueIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAboutRoute: typeof AuthedAboutRoute
  AuthedAccountRoute: typeof AuthedAccountRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedMetroIdRoute: typeof AuthedMetroIdRoute
  AuthedPassesIdRoute: typeof AuthedPassesIdRoute
  AuthedRidesIdRoute: typeof AuthedRidesIdRoute
  AuthedMetroIndexRoute: typeof AuthedMetroIndexRoute
  AuthedPassesIndexRoute: typeof AuthedPassesIndexRoute
  AuthedRidesIndexRoute: typeof AuthedRidesIndexRoute
  AuthedSupportIndexRoute: typeof AuthedSupportIndexRoute
  AuthedTripsIndexRoute: typeof AuthedTripsIndexRoute
  AuthedSupportCategoryIssueIdRoute: typeof AuthedSupportCategoryIssueIdRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAboutRoute: AuthedAboutRoute,
  AuthedAccountRoute: AuthedAccountRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedMetroIdRoute: AuthedMetroIdRoute,
  AuthedPassesIdRoute: AuthedPassesIdRoute,
  AuthedRidesIdRoute: AuthedRidesIdRoute,
  AuthedMetroIndexRoute: AuthedMetroIndexRoute,
  AuthedPassesIndexRoute: AuthedPassesIndexRoute,
  AuthedRidesIndexRoute: AuthedRidesIndexRoute,
  AuthedSupportIndexRoute: AuthedSupportIndexRoute,
  AuthedTripsIndexRoute: AuthedTripsIndexRoute,
  AuthedSupportCategoryIssueIdRoute: AuthedSupportCategoryIssueIdRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
